module.exports = __webpack_public_path__ + "img/edge_nature_eau.2fa24a06.svg";